<template>
  <div class="subsector livestock">
    <div class="parent-sector">
      <p>Overview</p>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-sm-12">
          <h1>Top 5 Emitters</h1>
          <p>
            In addition to global results, throughout this report each
            source category discussion includes information on top
            countries’ baseline projections and mitigation potential.
          </p>
          <div class="chartarea">
            <p class="center">
              <button @click="select('tab1')">2020</button>
              <button @click="select('tab2')">2050</button>
            </p>
            <div v-if="tab1">
              <Chart />
            </div>
            <div v-if="tab2">
              <Chart />
              <p>Caption goes here</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "./ChartOverviewPopup2";
import { EventBus } from "@/event-bus.js";

export default {
  components: {
    Chart
  },
  props: {
    msg: String
  },
  data() {
    return {
      tab1: true,
      tab2: false
    };
  },
  methods: {
    handler() {
      var args = arguments;
      for (var arg of args) {
        if (arg instanceof Function) {
          arg();
        }
      }
    },
    select(elem) {
      //alert("selection " + elem);
      this.currentView = elem;
      // this.activate(elem);
      if (this.currentView == "tab1") {
        //alert("Selected 2015 Data: " + elem);
        EventBus.$emit("btn-clicked", {
          newData: [7487, 2805, 1353, 988, 797, 600]
        });
      }
      if (this.currentView == "tab2") {
        //alert("Selected 2050 Data: " + elem);
        EventBus.$emit("btn-clicked", {
          newData: [2234, 1567, 991, 8887, 123, 242]
        });
      }
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: normal;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}
.subsector {
  background: url("../assets/bg-grey-bar.png") 0 0 repeat-x;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-radius: 5px;
}

.content {
  padding-top: 30px;
  padding-left: 50px;
  padding-right: 50px;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: 0;
}
.keypoints {
  border-left-style: solid;
  border-left-width: 5px;
  border-left-color: #b8da66;
  margin-left: 2rem;
}
.keypoints h3 {
  text-transform: uppercase;
  text-align: left;
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #333;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.keypoints ul {
  margin-left: 1.5rem;
}
.keypoints li {
  display: list-item;
  list-style-type: disc;
  margin-bottom: 0.8rem;
}
img {
  float: right;
  margin-top: 50px;
}
button {
  background-color: #0071bc;
  border-radius: 3px;
  border: 0;
  color: #fff;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
  margin-top: 2rem;
  cursor: pointer;
  margin-left: 1rem;
}
.chartarea button {
  position: static;
}
.parent-sector {
  position: static;
  z-index: 1;
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 10px;
  margin-left: 50px;
  color: #333;
}
</style>
